/* eslint-disable */
// import jwtInterceptor from "../Shared/jwtInterceptor";
import store from "../../store/index";
import axios from "axios";
export default {
  name: "newtemplate",
  props: { closeoption: String, formsesid: String ,fromArchive:Boolean},
  async beforeMount() {
    await this.setformid();
    await this.setArchive();
  },
  async mounted() {
    await this.setunverified();
    if(this.closeoption == "forms"){
    this.whenclosed = 'listform';
  }
  else if(this.closeoption == "sitesummary"){
    this.whenclosed = 'sitesummary'
  }
  else if(this.closeoption == "home"){
    this.whenclosed = 'home'
  }
  else if(this.closeoption == "patientlist"){
    this.whenclosed = 'patientlist'
  }
  else if(this.closeoption == "PatientScheduleView"){
    this.whenclosed = 'PatientScheduleView'
  }
  else if(this.closeoption == "iotaptents"){
    this.whenclosed = 'IOTPatients'
  }
  else if(this.closeoption == "showforms"){
    this.whenclosed = 'listform'
  }
  else if(this.closeoption == "submitForm"){
    this.whenclosed = 'submitForm'
  }
  else{
    this.whenclosed = 'formssummery'
  }
  },
  data() {
    return {
      whenclosed: '',
      baseurl: process.env.VUE_APP_Service_URL,
      // showpopup:
      //   this.$route.query.source !== "subject_schedule" &&
      //   this.closeoption !== "subject_schedule",
      showpopup: true,
      formsid: "",
      archive:false
}
  },
  methods: {
    async setformid(){
      this.formsid = this.formsesid;
    },
    async setArchive()
    {
      this.archive = this.fromArchive;
      console.log("setArchive", this.archive)
    },
    async setunverified(){
      console.log("unverified "+ this.formsid);
      const idtoken = store.getters.getIdToken;
      await axios
        .put(
          `${this.baseurl}/forms/forms/unverifyformstatus`,
          {
            "formId": this.formsid
          },
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log("form unverified "+ res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
}
};
